import { useMutation } from "react-query";
import { postData } from "../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../api/ajax-endpoints";
import { appInsights } from "../../../config/appInsights";
import { message } from "antd";
import { errorHandler } from "../../../helpers/errorHandler";
import { IResponse } from "../../../interfaces/response";

export type TLockUnlockUserPayload = {
  userId: string;
  reasonId: number;
  additionalInfo?: string;
};

const lockAdminUser = async (
  payload: TLockUnlockUserPayload,
): Promise<IResponse<any>> => {
  const { data } = await postData(ajaxEndpoints.LOCK_ADMIN_USER, payload);

  return data;
};

export function useLockAdminUser() {
  const [mutate, result] = useMutation(
    (payload: TLockUnlockUserPayload) => lockAdminUser(payload),
    {
      onSuccess: (data) => {
        message.success(
          data?.data?.message || `User has been locked successfully.`,
        );
      },
      onError: (error: any) => {
        appInsights.trackException({
          exception: error,
          properties: { fileName: "useLockAdminUser.ts" },
        });
        message.error(errorHandler(error));
      },
    },
  );

  return { mutate, result };
}
